import {Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize} from "rxjs/operators";

@Component({
  selector: 'app-scene',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: []
})
export class LoaderComponent extends PlayerContainer {
  loadType;
  loadId;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(playerObject.$.label, this.PREVIEW);
          return of(null);
        }
        this.loadStat();
        return of('load');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self) ),
      takeUntil(this.finish$)
    )
  }

  onCommand(command, param): Observable<any> {
    const cmd = command.$.command;
    switch (cmd) {
      case 'load':
        if (param.type=="scene" || param.type=="resource") {
          this.loadType = param.type;
          return of('a').pipe(
            switchMap( a=> {
              this.loadId = param.id;
              return this.showPage();
            }),
            catchError( err => {
              console.error(err);
              return of(null);
            })
          )
        }
      case 'clear':
        let oldChildComponent = null;
        if (this.childComponent != null) {
          oldChildComponent = this.childComponent;
          const oldLoader$ = this.childComponent.unload().pipe(
            finalize(() => {
              if (oldChildComponent.finish$ != null) {
                oldChildComponent.finish$.next("finish");
                oldChildComponent.finish$.complete();
                oldChildComponent.finish$ = null;
              }
              oldChildComponent.destroy();
              this.removeComponent(oldChildComponent);
            })
          )
          return oldLoader$;
        }
    }
    return of(null);
  }

  getPage(): Observable<any> {
    let player = null;
    if (this.loadType=="scene") {
      player = {$: {src: this.loadId}}
      return of(player);
    } if (this.loadType=="resource") {
      return this.playerService.caching.getRecord("resources", Number(this.loadId)).pipe(
        switchMap( resource => {
          if (resource != null) {
            player = {
              $: {
                player: (resource.resource_type == "mp4") ? 3100 : 3130,
                autoScaling: 1
              },
              Data: [{
                Resource: [{
                  $: {resource: this.loadId}
                }]
              }]
            }
            return of(player);
          } else {
            return of(null);
          }
        })
      )
    }

    return of(null);
  }


  destroy(): void {
    super.destroy();
  }
}
